import React from 'react'
import { Route } from 'react-router'

import EmptyLayout from 'Layouts/EmptyLayout'
import MainLayout from 'Layouts/MainLayout'

import DebugModule from 'Modules/DebugModule'
import DesignerQueueModule from 'Modules/DesignerQueueModule'
import FamilyAlbumDetailModule from 'Modules/FamilyAlbumDetailModule'
import FamilyAlbumModule from 'Modules/FamilyAlbumModule'
import GroupDetailModule from 'Modules/GroupDetailModule'
import GroupsModule from 'Modules/GroupsModule'
import MainModule from 'Modules/MainModule'
import MarkedForDesignersModule from 'Modules/MarkedForDesignersModule'
import MyOrdersModule from 'Modules/MyOrdersModule'
import MySearchesModule from 'Modules/MySearchesModule'
import RequestedRugsModule from 'Modules/RequestedRugsModule'
import RugDetailModule from 'Modules/RugDetailModule'
import SearchModule from 'Modules/SearchModule'
import SignInModule from 'Modules/SignInModule'
import StatusModule from 'Modules/StatusModule'
import UserDetailModule from 'Modules/UserDetailModule'
import UsersModule from 'Modules/UsersModule'

import requireAuth from 'HigherOrderComponents/RequireAuth'

export default (
  <div>
    <Route component={requireAuth(MainLayout)}>
      <Route path="/" component={MainModule} />
      <Route path="/debug" component={DebugModule} />
      <Route path="/designerQueue" component={DesignerQueueModule} />
      <Route path="/familyAlbum" component={FamilyAlbumModule} />
      <Route path="/familyAlbum/search" component={FamilyAlbumDetailModule} />
      <Route path="/familyAlbum/:eventId" component={FamilyAlbumDetailModule} />
      <Route path="/groups" component={GroupsModule} />
      <Route path="/groups/:id" component={GroupDetailModule} />
      <Route path="/markedForDesigners" component={MarkedForDesignersModule} />
      <Route path="/myOrders" component={MyOrdersModule} />
      <Route path="/mySearches" component={MySearchesModule} />
      <Route path="/requestedRugs" component={RequestedRugsModule} />
      <Route path="/rug/:rugId" component={RugDetailModule} />
      <Route path="/search" component={SearchModule} />
      <Route path="/status" component={StatusModule} />
      <Route path="/user/:userId" component={UserDetailModule} />
      <Route path="/users" component={UsersModule} />
    </Route>

    <Route component={EmptyLayout}>
      <Route path="/signIn" component={SignInModule} />
    </Route>
  </div>
)
